export enum StorageType {
    DIRECT_SHIP = 'DIRECT_SHIP',
    THIRD_PARTY_WAREHOUSE = 'THIRD_PARTY_WAREHOUSE',
    OWN_WAREHOUSE = 'OWN_WAREHOUSE',
}
